import { effect, inject, Injectable, untracked } from '@angular/core';
import { Region } from 'angular-api-gateway/v1/model/region';
import { AuthFacade } from '@lentau/auth/store';
import { CityStoreFacade } from '@lentau/city/store/city.facade';
import { AuthStepEnum } from '@lentau/auth/shared';
import { CityNavigateHelperService } from './city-navigate-helper.service';
import { CityChangeService } from './city-change.service';
import { isUtk } from '@lentau/ui-kit/core/helpers/isBrand.helper';
import { CitySlugCacheService } from './city-slug-cache.service';
import { CityCacheService } from './city-cache.service';

@Injectable({
  providedIn: 'root',
})
export class CityService {
  private cityFacade: CityStoreFacade = inject(CityStoreFacade);
  private cityNavigateHelperService: CityNavigateHelperService = inject(CityNavigateHelperService);
  private cityChangeService: CityChangeService = inject(CityChangeService);
  private citySlugCacheService: CitySlugCacheService = inject(CitySlugCacheService);
  private cityCacheService: CityCacheService = inject(CityCacheService);
  private authFacade: AuthFacade = inject(AuthFacade);

  public isRedirectDisabled: boolean = this.cityChangeService.isRedirectDisabled();

  public init(): void {
    if (!isUtk()) {
      this.setCurrentCity();
    }
  }

  public citySelect(selectedCity: Region): void {
    // Если город с бэка отличается от кеша или нет кеша
    if (selectedCity && (!this.cityFacade.city() || this.cityFacade.city().id !== selectedCity.id)) {
      this.cityFacade.setCity(selectedCity);
      // устанавливаем кеш города
      this.cityCacheService.updateCacheCity(selectedCity);
      this.citySlugCacheService.updateCacheCitySlug(selectedCity.slug);
    }
  }

  private setCurrentCity(): void {
    effect(() => {
      const cityId: number = this.cityFacade.cityId();
      const cities: Region[] = this.cityFacade.cities();

      if (!cityId || !(cities?.length > 0)) return;

      untracked(() => {
        const city: Region = cities.find((city: Region) => city.id === cityId);

        if (
          city.slug !== this.cityFacade.citySlug() &&
          !this.isRedirectDisabled &&
          this.authFacade.currentAuthStep() !== AuthStepEnum.SELECTING_PROFILE
        ) {
          this.navigateToRegion(city);
        } else {
          this.citySelect(city);
        }
      });
    });
  }

  private navigateToRegion(city: Region): void {
    this.cityCacheService.updateCacheCity(city);

    if (city.mainDomain) {
      return this.navigateToDefaultHost();
    }

    if (this.cityNavigateHelperService.regionByUrl !== city.slug) {
      this.cityChangeService.navigateToRegion(city.slug);
    }
  }

  private navigateToDefaultHost(): void {
    this.cityChangeService.navigateToDefaultUrl(this.cityFacade.cities());
  }
}
